/**
* Copyright 2012-2020, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/

'use strict';

module.exports = {
    attributes: require('./attributes'),
    supplyDefaults: require('./defaults'),
    crossTraceDefaults: require('../histogram/cross_trace_defaults'),
    calc: require('../heatmap/calc'),
    plot: require('../heatmap/plot'),
    layerName: 'heatmaplayer',
    colorbar: require('../heatmap/colorbar'),
    style: require('../heatmap/style'),
    hoverPoints: require('./hover'),
    eventData: require('../histogram/event_data'),

    moduleType: 'trace',
    name: 'histogram2d',
    basePlotModule: require('../../plots/cartesian'),
    categories: ['cartesian', 'svg', '2dMap', 'histogram', 'showLegend'],
    meta: {
        
        
    }
};
